// extracted by mini-css-extract-plugin
export default {"mainContainer":"Buy_mainContainer__W7+CK","container":"Buy_container__eqIzK","content":"Buy_content__Kb48U","left":"Buy_left__8IZQM","right":"Buy_right__fhFjN"};